var data = {
  modelo: {
    grupo_1: {
      altura: {
        "<1.75": {
          forma: {
            delgado: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "M",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            dad_bod: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            normal: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            musculoso: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            poco_sobrepeso: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            sobrepeso: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
          },
        },
        "<1.80": {
          forma: {
            delgado: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            dad_bod: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            normal: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            musculoso: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            poco_sobrepeso: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
          },
        },
        "<1.85": {
          forma: {
            delgado: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            dad_bod: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            normal: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            musculoso: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            poco_sobrepeso: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
          },
        },
        "<1.90": {
          forma: {
            delgado: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            dad_bod: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            normal: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            musculoso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            poco_sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
          },
        },
        ">=1.90": {
          forma: {
            delgado: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            dad_bod: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            normal: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            musculoso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            poco_sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
          },
        },
      },
    },
    grupo_2: {
      altura: {
        "<1.75": {
          forma: {
            delgado: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "M",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            dad_bod: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            normal: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "M",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            musculoso: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            poco_sobrepeso: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
          },
        },
        "<1.80": {
          forma: {
            delgado: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "M",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            dad_bod: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "M",
                },
                suelto: {
                  talla: "L",
                },
              },
            },
            normal: {
              calce: {
                ajustado: {
                  talla: "M",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            musculoso: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            poco_sobrepeso: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            sobrepeso: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
          },
        },
        "<1.85": {
          forma: {
            delgado: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            dad_bod: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            normal: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "L",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            musculoso: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            poco_sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
          },
        },
        "<1.90": {
          forma: {
            delgado: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            dad_bod: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            normal: {
              calce: {
                ajustado: {
                  talla: "L",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            musculoso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            poco_sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
          },
        },
        ">=1.90": {
          forma: {
            delgado: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            dad_bod: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            normal: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            musculoso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            poco_sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
            sobrepeso: {
              calce: {
                ajustado: {
                  talla: "XL",
                },
                regular: {
                  talla: "XL",
                },
                suelto: {
                  talla: "XL",
                },
              },
            },
          },
        },
      },
    },
  },
};
